<script>
  export let items = [];
</script>

{#if !items.length}
  <p class="muted">No line items on this order.</p>
{:else}
  <ul class="picklist">
    {#each items as it (it.id)}
      <li>
        <div class="thumb">
          {#if it.imageUrl}<img src={it.imageUrl} alt={it.title} loading="lazy" />{:else}<div class="ph"></div>{/if}
        </div>
        <div class="info">
          <div class="title">{it.title}</div>
          {#if it.variantTitle && it.variantTitle !== 'Default Title'}<div class="variant">{it.variantTitle}</div>{/if}
          <div class="meta">
            {#if it.sku}<span>SKU {it.sku}</span>{/if}
            {#if it.barcode}<span class="bc">{it.barcode}</span>{/if}
          </div>
        </div>
        <div class="qty">×{it.quantity}</div>
      </li>
    {/each}
  </ul>
{/if}

<style>
  .picklist { list-style: none; padding: 0; margin: 0; }
  li { display: flex; align-items: center; gap: .9rem; padding: .7rem 0; border-bottom: 1px solid #f0f0f0; }
  .thumb { width: 56px; height: 56px; flex: 0 0 56px; }
  .thumb img, .ph { width: 56px; height: 56px; object-fit: cover; border-radius: 6px; background: #f0f0f0; }
  .info { flex: 1; min-width: 0; }
  .title { font-weight: 600; }
  .variant { font-size: .85rem; color: #555; }
  .meta { font-size: .78rem; color: #777; margin-top: .15rem; display: flex; gap: .6rem; }
  .meta .bc { font-family: ui-monospace, monospace; }
  .qty { font-weight: 700; font-size: 1.05rem; white-space: nowrap; }
  .muted { color: #777; }
</style>
